import AuthView from './Auth.View';

const Auth = () => <AuthView />;

export default Auth;
